import { getInitials } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarAvatar } from './avatar';
import { SonarText } from './text';
import { SonarUserTooltip } from './SonarUserTooltip';
import { useCurrentUser } from '@hooks';
import { AvatarProps, Space } from 'antd';

export interface SalesforceUserProps {
	avatar?: boolean;
	className?: string;
	large?: boolean;
	name?: string;
	placeholder?: string;
	shape?: AvatarProps['shape'];
	showTooltip?: boolean;
	username: string;
	withFullName?: boolean;
}

export const SalesforceUser: React.FC<SalesforceUserProps> = ({
	avatar = true,
	className,
	large,
	name = '',
	placeholder,
	shape,
	showTooltip,
	username,
	withFullName = true
}) => {
	const { isGuest } = useCurrentUser();
	const [ firstName, lastName ] = name.split(' ');

	const initials = getInitials(firstName, lastName);

	let avatarElement;
	let labelElement;

	if (avatar) {
		avatarElement =
			<SonarAvatar
				className={ className }
				isPlaceholder={ !name }
				large={ large }
				shape={ shape }>
				{ initials }
			</SonarAvatar>;
	}

	if (withFullName || placeholder) {
		labelElement = <SonarText className='salesforce-user-label'>{ name.length ? name : placeholder }</SonarText>;
	}

	const userBase =
		<Space
			className='salesforce-user'
			key={ username }
			size={ 8 }>
			{ avatarElement }
			{ labelElement }
		</Space>;
	if (showTooltip && !isGuest) {
		return (
			<SonarUserTooltip
				avatar={ avatarElement }
				email={ username }
				name={ name }>
				{ userBase }
			</SonarUserTooltip>
		);
	}

	return userBase;
};
